import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export const CollapsibleCard = ({
  title,
  icon: Icon,
  iconClass = "",
  borderClass = "",
  defaultOpen = true,
  testId,
  children
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`card-dark p-6 mb-6 ${borderClass}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-2 text-left"
        data-testid={testId}
        aria-expanded={open}
      >
        <h2 className="text-lg font-semibold text-white flex items-center gap-2">
          {Icon && <Icon className={`w-5 h-5 ${iconClass}`} />}
          {title}
        </h2>
        <span className="flex items-center justify-center w-7 h-7 rounded-full bg-[#2A3A4D] text-white hover:bg-[#00E073] hover:text-[#0D1C32] transition-colors">
          {open ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
        </span>
      </button>
      {open && <div className="mt-4">{children}</div>}
    </div>
  );
};

export default CollapsibleCard;
